import { render, staticRenderFns } from "./notificationOnly.vue?vue&type=template&id=66bb8ed2&scoped=true"
import script from "./notificationOnly.vue?vue&type=script&lang=js"
export * from "./notificationOnly.vue?vue&type=script&lang=js"
import style0 from "./notificationOnly.vue?vue&type=style&index=0&id=66bb8ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb8ed2",
  null
  
)

export default component.exports